

export type FileTypes = 'application/pdf' | 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' | 'application/zip';

export enum FILE_TYPES {
    PDF = 'application/pdf',
    XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ZIP = 'application/zip'
}

export enum FILE_TYPES_EXTENSION {
    PDF = '.pdf',
}